/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  }

  growApp.prototype.enterAnimation = function () {
    let $mainVisual = $('.c-main-visual');
    if (!$mainVisual.length === 0) {
      return false;
    }

    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.addClass(className);
          resolve(className);
        }, time);
      });
    }

    var loaderFunction = function () {
      // ここから実行
      if ($mainVisual) {
        changeClass($mainVisual, "is-active", 1000).then(function () {

        });
      }
    };

    // first entry only
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      $mainVisual.addClass('is-already');
    }
  };

  //モーダル
  growApp.prototype.originmodal = function () {

    //モーダルを開いた時のスクロール位置を保持
    var scrollPosition;
    //iOS（iPadOSを含む）かどうかのUA判定
    var ua = window.navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

    //bodyのスクロール固定
    function bodyFixedOn() {
      if(isiOS){
        // iOSの場合
        scrollPosition = $(window).scrollTop();
        $('body').css('position', 'fixed');
        $('body').css('top', '-' + scrollPosition + 'px');
      }else {
        // それ以外
        $('body').css('overflow', 'hidden');
      }
    }

    //bodyのスクロール固定を解除
    function bodyFixedOff() {
      if(isiOS){
        // iOSの場合
        $('body').css('position', '');
        $('body').css('top', '');
        $(window).scrollTop(scrollPosition);
      }else {
        // それ以外
        $('body').css('overflow', '');
      }
    }

    $('.js-allergy-modal').on('click', function (e) {
      const $item = $(this);
      const modalId = $item.data("teacher-target");
      const $modal = $('.c-allergy-modal[data-teacher-content="' +  modalId + '"]');

      e.preventDefault();

      if ($modal.hasClass("is-active")) {
        $modal.removeClass('is-active');
        $modal.addClass("is-hidden");
        bodyFixedOff();
        setTimeout(() => {
          $modal.removeClass("is-hidden");
        }, 500);
      } else {
        $modal.addClass('is-active');
        bodyFixedOn();
      }
    });


    $('.c-allergy-modal__close, .c-allergy-modal__overlay').on('click', function (e) {
      const $modal = $(this).parents('.c-allergy-modal');
      $modal.removeClass('is-active');
      $modal.addClass("is-hidden");
      bodyFixedOff();
      setTimeout(() => {
        $modal.removeClass("is-hidden");
      }, 500);
    });
  }

  growApp.prototype.pageTop = function () {
    $(window).scroll(function(){
      var top = $(".l-footer").offset().top; // ターゲットの位置取得
      var position = top - $(window).height();  // 発火させたい位置

      if($(window).scrollTop() > position){
        $('.c-pagetop').removeClass("is-fixed");
      }else{
        $('.c-pagetop').addClass("is-fixed");
      }
    })
  }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.enterAnimation();
    app.originmodal();
    app.pageTop();
  });
})(jQuery);
